try{
function initVideo(section){
  const wrapper = section.querySelector('.video-frame');
  const video   = section.querySelector('.video-el');
  const toggle  = section.querySelector('.video-toggle');
  const icon    = section.querySelector('.video-icon');
  const btn     = section.querySelector('[data-desktop-style]');
  if(!video || !toggle){console.warn('Video or toggle element not found', {video, toggle}); return;}
  console.log('Video initialized', {video, toggle});
  const sources = video.querySelectorAll('source');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  let allowVideo = true;
  if(connection){
    const type = connection.effectiveType;
    if(type === 'slow-2g' || type === '2g' || connection.saveData){allowVideo = false;}
  }
  if(video.canPlayType){
    const mp4Support = video.canPlayType('video/mp4');
    const hlsSupport = video.canPlayType('application/x-mpegURL');
    console.log('Video codec support:', {mp4: mp4Support||'no', hls: hlsSupport||'no', hlsStatus: hlsSupport?'enabled':'check fallback'});
  }
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const load   = section.dataset.load;
  const mql    = window.matchMedia('(max-width:767px)');
  /* Base Video Attributes */
  video.muted = true;
  video.setAttribute('muted','');
  video.setAttribute('playsinline','');
  video.setAttribute('webkit-playsinline','');
  video.removeAttribute('controls');
  /* Video event listeners */
  video.addEventListener('play', function(){section.classList.add('video-ready');});
  video.addEventListener('error', function(){console.error('Video error:', video.error?.message); setPause(); video.controls = true;});
  video.addEventListener('canplay', function(){console.log('Ready:', video.currentSrc); video.setAttribute('data-video-ready', '');});
  video.addEventListener('stalled', function(){});
  video.addEventListener('suspend', function(){});
  /* Button Variant Sync */
  function syncButtonVariant(){
    if(!btn) return;
    const desktop = btn.dataset.desktopStyle;
    const mobile  = btn.dataset.mobileStyle;
    btn.classList.remove('btn-transparent','btn-light');
    const target = mql.matches ? mobile : desktop;
    if(target !== 'default'){btn.classList.add(target);}
  }
  /* Icon States */
  function setPlay(){
    toggle.setAttribute('aria-label','Pause video');
    toggle.setAttribute('aria-pressed','true');
    icon.innerHTML = '<line x1="8" y1="5" x2="8" y2="19"></line><line x1="16" y1="5" x2="16" y2="19"></line>';
  }
  function setPause(){
    toggle.setAttribute('aria-label','Play video');
    toggle.setAttribute('aria-pressed','false');
    icon.innerHTML = '<polygon points="9,6 19,12 9,18"></polygon>';
  }
  video.addEventListener('play', setPlay);
  video.addEventListener('pause', setPause);
  /* Autoplay Attempt */
  function attemptAutoplay(){
    return video.play().then(function(){setPlay();}).catch(function(){setPause(); enableTapToPlay();});
  }
  /* Low Power Mode Tap Fallback */
  function enableTapToPlay(){
    function startPlayback(){
      if(!video.paused) return;
      video.play().then(function(){setPlay(); video.controls = false;}).catch(function(){video.controls = true;});
    }
    wrapper.addEventListener('touchstart', startPlayback, {once:true, passive:true});
    wrapper.addEventListener('click', startPlayback, {once:true});
  }
  /* Toggle Button */
  toggle.addEventListener('click',function(e){
    e.preventDefault();
    if(video.paused){
      const playPromise = video.play();
      if(playPromise !== undefined){
        playPromise.then(function(){console.log('Video playing'); setPlay();}).catch(function(err){console.error('Play failed:', err); setPause();});
      }
    }else{
      video.pause();
      setPause();
    }
  });
  /* Initial Setup */
  function update(){
    if(!allowVideo){console.log('Slow connection — showing poster only'); return;}
    syncButtonVariant();
  }
  mql.addEventListener('change',update);
  window.addEventListener('resize',syncButtonVariant);
  update();
  enableTapToPlay();
  /* Autoplay Logic */
  function autoplay(){
    if(!reduce && video.hasAttribute('autoplay')){attemptAutoplay();}else{setPause();}
  }
  if(load === 'immediate'){console.log('Load strategy: immediate - starting autoplay now'); autoplay();}
  if(load === 'lazy'){
    console.log('Load strategy: lazy - setting up intersection observer');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          console.log('Video entering viewport - triggering autoplay');
          /* Load poster sources if they're deferred */
          const picture = video.parentElement.querySelector('.video-poster[data-poster="lazy"]');
          if(picture){
            const posterSources = picture.querySelectorAll('source[data-srcset]');
            posterSources.forEach(source => {
              const srcset = source.getAttribute('data-srcset');
              source.setAttribute('srcset', srcset);
              source.removeAttribute('data-srcset');
            });
            const posterImg = picture.querySelector('img[data-src]');
            if(posterImg){
              const src = posterImg.getAttribute('data-src');
              posterImg.setAttribute('src', src);
              posterImg.removeAttribute('data-src');
            }
          }
          /* Load video sources */
          const sources = video.querySelectorAll('source[data-src]');
          sources.forEach(source => {
            const url = source.getAttribute('data-src');
            source.setAttribute('src', url);
            source.removeAttribute('data-src');
          });
          try{video.load();}catch(err){}
          autoplay();
          observer.disconnect();
        }
      });
    },{threshold: 0.1});
    observer.observe(video);
  }
}
if(!window.videoDOMContentListenerAdded){
  window.videoDOMContentListenerAdded = true;
  document.addEventListener('DOMContentLoaded', function(){
    const sections = document.querySelectorAll('[data-video]');
    if(sections.length === 0){console.log('NV:true'); return;}
    sections.forEach(function(section, index){
      console.log('Initializing video section', index);
      try{initVideo(section);}catch(err){console.error('Error initializing video section', index, err);}
    });
  });
}
document.addEventListener('shopify:section:load', function(e){
  console.log('Shopify section loaded');
  const section = e.target.querySelector('[data-video]');
  if(section){
    console.log('Initializing loaded section');
    try{initVideo(section);}catch(err){console.error('Error initializing loaded section:', err);}
  }
});
}catch(err){console.error('Error loading video-section:', err);}
